import { styled } from '@mui/material/styles';
import ProfileProgress from '@components/ProfileProgress';
import { Typography } from '@components/Typography';
import { completenessLevelForScore, COMPLETENESS_LEVEL_TRANSLATION_KEY } from '@constants/companies';
import { useTranslation } from '@hooks';
import { useLiveScoreValue } from './LiveScoreProvider';

const Summary = styled('span')({
    display: 'flex',
    alignItems: 'center',
    gap: 16,
});

const SummaryText = styled('span')({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    minWidth: 0,
});

const ScoreSummary = () => {
    const { t } = useTranslation();
    const { percent } = useLiveScoreValue();
    const level = completenessLevelForScore(percent);

    return (
        <Summary>
            <ProfileProgress value={percent} level={level} />
            <SummaryText>
                <Typography variant="subtitle1" component="span" sx={{ color: 'var(--text-primary)' }}>
                    {t('SettingsCompanies.optimizationScore')}
                </Typography>
                <Typography variant="body2" component="span" sx={{ color: 'var(--text-secondary)' }}>
                    {t(COMPLETENESS_LEVEL_TRANSLATION_KEY[level])}
                </Typography>
            </SummaryText>
        </Summary>
    );
};

export default ScoreSummary;
